import { React, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useAxios from "../../../../utilities/useAxios";
import PageTitle from "../../../PageTitle";
import { Form, Input, Button, Card, message } from "antd";

const EditAccessedCar = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		getAccessedCarData();
		// eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount
	}, []);

	const getAccessedCarData = async () => {
		try {
			const response = await useAxios.get(
				"/utils/accessed-car/" + String(id) + "/"
			);
			if (response.status === 200) {
				form.setFieldsValue(response.data.accessed_car);
			}
		} catch (error) {
			message.error("차량 정보를 불러오는데 실패했습니다.");
		} finally {
			setLoading(false);
		}
	};

	const onFinish = async (values) => {
		try {
			const response = await useAxios.put(
				"/utils/accessed-car/" + String(id) + "/",
				{
					...values,
					inst_detail: values.inst_detail || null,
				}
			);
			if (response.status === 200) {
				message.success(
					"차량 정보가 성공적으로 수정되었습니다."
				);
				if (
					window.opener &&
					window.opener.refreshAccessedCars
				) {
					window.opener.refreshAccessedCars();
				}
				window.close();
			}
		} catch (error) {
			message.error(
				error.response?.data?.message ||
					"차량 정보 수정 중 오류가 발생했습니다."
			);
		}
	};

	return (
		<>
			<PageTitle title="차량 정보 수정" />
			<div className="utils-accessed_car__container">
				<div className="utils-accessed_car__header">
					<h1 className="utils-accessed_car__header__title">
						차량 정보 수정
					</h1>
				</div>
				<div className="utils-accessed_car__content-container">
					<Card className="utils-accessed_car__form-card">
						<Form
							form={form}
							layout="vertical"
							onFinish={onFinish}
							autoComplete="off"
							disabled={loading}>
							<Form.Item
								label="차주"
								name="owner"
								rules={[
									{
										required: true,
										message: "차주를 입력해주세요",
									},
								]}>
								<Input placeholder="차주 이름을 입력하세요" />
							</Form.Item>

							<Form.Item
								label="소속"
								name="inst"
								rules={[
									{
										required: true,
										message: "소속을 입력해주세요",
									},
								]}>
								<Input placeholder="소속을 입력하세요" />
							</Form.Item>

							<Form.Item
								label="세부소속"
								name="inst_detail">
								<Input placeholder="세부소속을 입력하세요" />
							</Form.Item>

							<Form.Item
								label="차량번호"
								name="car_num">
								<Input
									disabled
								/>
							</Form.Item>

							<Form.Item
								label="차주 연락처"
								name="owner_tel"
								rules={[
									{
										pattern: /^[0-9-]+$/,
										message: "숫자와 하이픈(-)만 입력 가능합니다",
										required: true,
									},
								]}>
								<Input placeholder="연락처를 입력하세요" />
							</Form.Item>

							<Form.Item>
								<div className="utils-accessed_car__form-actions">
									<Button
										type="primary"
										htmlType="submit">
										수정
									</Button>
									<Button
										onClick={() =>
											navigate(
												-1
											)
										}>
										취소
									</Button>
								</div>
							</Form.Item>
						</Form>
					</Card>
				</div>
			</div>
		</>
	);
};

export default EditAccessedCar;
